import React, { useEffect, useState } from 'react';
import { Tag, Tooltip } from 'antd';
import apiService, { ServiceType } from '../../services/api';

type State = { mode: string; state: 'IN_SYNC' | 'STALE' | 'DIVERGED' | 'NO_MONEY' | 'TERMINAL_ONLY' | 'SERVER'; reportedAt: string | null; reasons: string[] };

const LOOK: Record<State['state'], { color: string; text: string; help: string } | null> = {
  SERVER: null,
  IN_SYNC: { color: 'green', text: 'Terminal: in sync', help: 'The Fortuna terminal reported this account recently and its holdings match the bots.' },
  STALE: { color: 'gold', text: 'Terminal: not reporting', help: 'The terminal has not reported this account recently: open it so starts can go ahead.' },
  DIVERGED: { color: 'red', text: 'Terminal: holdings differ', help: 'The broker holds less than the bots count. Reconcile in the terminal before starting.' },
  NO_MONEY: { color: 'gold', text: 'Waiting for the terminal: balance', help: "The terminal has not reported this account's balance yet: its bots buy nothing until it does. Open the terminal." },
  TERMINAL_ONLY: { color: 'default', text: 'Managed in the terminal', help: 'Its owner keeps this account to the Fortuna terminal: here it is shown, and a bot may be stopped.' },
};

/** How far the web can trust a terminal account (BE GET portfolios/:id/sync-state). Nothing for
 *  an account Fortuna trades itself. */
const SyncBadge: React.FC<{ portfolioId?: string | null }> = ({ portfolioId }) => {
  const [st, setSt] = useState<State | null>(null);
  useEffect(() => {
    if (!portfolioId) return setSt(null);
    let live = true;
    const load = () =>
      apiService.getService(ServiceType.CORE).get<State>(`/portfolios/${portfolioId}/sync-state`)
        .then((r) => live && setSt(r.data)).catch(() => live && setSt(null));
    load();
    const id = window.setInterval(load, 30_000);
    return () => { live = false; window.clearInterval(id); };
  }, [portfolioId]);
  const look = st ? LOOK[st.state] : null;
  if (!st || !look) return null;
  return (
    <Tooltip title={[look.help, ...st.reasons].join(' ')}>
      <Tag color={look.color} style={{ marginRight: 0 }}>{look.text}</Tag>
    </Tooltip>
  );
};

export default SyncBadge;
